import { Dropdown_Button_default } from "./chunk-O7XK6FWK.js";
import { Dropdown_Panel_default } from "./chunk-XMYSGWF4.js";
import { Dropdown_default } from "./chunk-JNQGZ3PW.js";

// src/elements/Dropdown/index.ts
var DropdownComponent = Dropdown_default;
DropdownComponent.Button = Dropdown_Button_default;
DropdownComponent.Button.displayName = "Dropdown.Button";
DropdownComponent.Panel = Dropdown_Panel_default;
DropdownComponent.Panel.displayName = "Dropdown.Panel";
export { DropdownComponent };